import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-bs4/js/dataTables.bootstrap4';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4';
import 'datatables.net-select-bs4/js/select.bootstrap4';
import 'bootstrap-datepicker';
import '../components/hs-datatables';
import 'yadcf/jquery.dataTables.yadcf';

export default {

  init() {


  },
  finalize() {

    // initialization of datatables found on page
    $.HSCore.components.HSDatatables.init('.js-datatable', {
      ajax: {
        type: 'POST',
        url: ajaxdta.ajaxurl,
        data: ({
          'action': "get_survey_one_results",
          'nonce': ajaxdta._nonce
        }),
        dataSrc: 'data',
      },
      processing: true,
      serverSide: true,
      columnDefs: [
        {targets: [0], searchable: false, orderable: true},
        {targets: [1, 2, 3, 4, 6, 7, 8, 9], searchable: true, orderable: true},
        {targets: [5], searchable: true, orderable: false},
        {targets: ['_all'], searchable: false, orderable: false}
      ],
      buttons: [
        {
          extend: 'csv',
          text: 'Export to CSV',
          className: 'btn btn-primary btn-sm mr-2',
          init: function(api, node, config) {
            $(node).removeClass('btn-secondary')
          },
          action: function (e, dt, node, config) {
            const d = dt.ajax.params();
            $.extend( d, {"method": 'csv'});
            $.ajax({
              type: 'POST',
              url: ajaxdta.ajaxurl,
              data: d,
              success: function (res, status, xhr) {
                var csvData = new Blob([res], {type: 'text/csv;charset=utf-8;'});
                var csvURL = window.URL.createObjectURL(csvData);
                var tempLink = document.createElement('a');
                tempLink.href = csvURL;
                tempLink.setAttribute('download', 'survey_one_results_export.csv');
                tempLink.click();
              }
            })
          }
        },
      ],
      yadcfColSettings: [
        {
          column_number: 0,
          filter_delay: 3000,
          filter_container_id: 'datepickerWrapper',
          filter_type: 'range_date',
          datepicker_type: 'bootstrap-datepicker',
          date_format: "yyyy-mm-dd",
          moment_date_format: "DD-MM-YYYY",
          style_class: 'd-flex',
          reset_button_style_class: 'btn btn-outline-primary btn-sm float-left ml-2 border',
        },
        {
          column_number: 1,
          filter_delay: 100,
          filter_default_label: 'Lesson',
          filter_container_id: 'lessonFilter',
          style_class: 'form-control form-control-sm w-75 d-inline mr-2',
          reset_button_style_class: 'btn btn-outline-primary btn-sm border',
        },
        {
          column_number: 7,
          filter_delay: 100,
          filter_default_label: 'Setting',
          filter_container_id: 'settingFilter',
          style_class: 'form-control form-control-sm w-75 d-inline mr-2',
          reset_button_style_class: 'btn btn-outline-primary btn-sm border',
        },

        {
          column_number: 8,
          filter_delay: 100,
          filter_default_label: 'Occupation',
          filter_container_id: 'occupationFilter',
          style_class: 'form-control form-control-sm w-75 d-inline mr-2',
          reset_button_style_class: 'btn btn-outline-primary btn-sm border',
        },
        {
          column_number: 9,
          filter_delay: 100,
          filter_default_label: 'State',
          filter_container_id: 'stateFilter',
          style_class: 'form-control form-control-sm w-75 d-inline mr-2',
          reset_button_style_class: 'btn btn-outline-primary btn-sm border',
        }
      ],
    });

  }
};



// WEBPACK FOOTER //
// ./scripts/routes/survey-one-results.js